/**
 * Utility to map paths between IT and EN locales.
 * Canonical IT paths <-> SEO-optimised EN paths.
 */

export const PATH_IT_TO_EN = {
  "/": "/en",
  "/come-funziona": "/en/how-it-works",
  "/tariffe": "/en/pricing",
  "/tariffe/listino": "/en/pricing/list",
  "/tariffe/configuratore": "/en/pricing/configurator",
  "/per-chi": "/en/who-its-for",
  "/contatti": "/en/contact",
  "/privacy": "/en/privacy",
  "/termini": "/en/terms",
};

export const PATH_EN_TO_IT = Object.fromEntries(
  Object.entries(PATH_IT_TO_EN).map(([it, en]) => [en, it])
);

/** Return the language ('it' | 'en') implied by a URL path. */
export const langFromPath = (pathname) => {
  if (!pathname) return "it";
  return pathname === "/en" || pathname.startsWith("/en/") ? "en" : "it";
};

/** Return the localised version of an IT path for the given language. */
export const localizePath = (itPath, lang) => {
  if (lang !== "en") return itPath;
  return PATH_IT_TO_EN[itPath] || itPath;
};

/** Return the equivalent path in the opposite language. */
export const alternatePath = (currentPath) => {
  if (currentPath in PATH_IT_TO_EN) return PATH_IT_TO_EN[currentPath];
  if (currentPath in PATH_EN_TO_IT) return PATH_EN_TO_IT[currentPath];
  return currentPath;
};
